<template>
  <div class="content-section" id="work-experience">
    <section-title>Experience</section-title>
    <div class="content-section__body experiences-body">
      <work-experience-entry
        v-for="(entry, i) in work" 
        :key="i"
        :company="entry.company"
        :position="entry.position"
        :description="entry.description"
        :duration="entry.duration"
        :stacks="entry.stacks"
      />
    </div>
  </div>
</template>

<script>
import workExperienceData from 'data/work-experience.json';
import SectionTitle from '@/components/utilities/SectionTitle.vue';
import WorkExperienceEntry from './WorkExperienceEntry.vue';
export default {
  name: 'WorkExperience',

  components: {
    WorkExperienceEntry,
    SectionTitle,
  },

  data: () => ({
    work: workExperienceData.work,
    old: [
      /* { */
      /*   company: { */
      /*     name: 'NUS Fintech Society', */
      /*     image_path: 'nus-fintech-soc.jpeg', */
      /*   }, */
      /*   position: 'Tech Lead', */
      /*   description: ` */
      /* <div class="ml-6"> */
      /* <ul> */
      /* <li>Managing a team of developers to build two software projects from scratch</li> */
      /*           <li>In charge of <b>DevOps</b>, project architecture and designing development workflows</li> */
      /* <li>Conducted code reviews, sprint planning, and project management using <b>Agile methodologies</b></li> */
      /* </ul> */
      /* </div> */
      /* `, */
      /*   duration: 'Sep 2021 - Present', */
      /*   stacks: [ */
      /*     'react', */
      /*     'nextjs', */
      /*     'nodejs', */
      /*     'expressjs', */
      /*     'materialui', */
      /*     'postgresql', */
      /*   ], */
      /* }, */
    ],
  }),
};
</script>

<style lang="scss" scoped>
.experiences-body {
  max-width: 800px;
  margin: 0 auto;
}
</style>
